<app-breadcrumbs></app-breadcrumbs>
<div class="button-container">
    <button mat-raised-button (click)="submit()" color="primary" id="submit-button">
        Submit
    </button>
    <button mat-raised-button (click)="clear()" color="secondary" id="submit-button">
        Clear
    </button>
</div>
<div class="container">
    <div class="network-form-wrapper">
        <app-meraki-network-form></app-meraki-network-form>
    </div>
    <div class="switch-form-wrapper">
        <div #addSwitchHere></div>
    </div>
    <div class="switch-control-wrapper">
        <div class="plus-button-wrapper">
            <button mat-raised-button (click)="addSwitchToForm()" color="secondary">
                Add switch
            </button>
        </div>
        <div class="minus-button-wrapper">
            <button mat-raised-button (click)="removeSwitchFromForm()" color="warn">
                Remove switch
            </button>
        </div>
    </div>
</div>